export const en = {
    notifications: 'Notifications'
};
